var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pa-4" },
    [
      _vm.dtIsLoading
        ? _c("v-progress-linear", {
            attrs: {
              indeterminate: _vm.dtIsLoading,
              color: "primary",
              height: "2"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-layout",
            { staticClass: "mb-3", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs3: "" } }, [
                _c("span", { staticClass: "primary--text" }, [
                  _vm._v(
                    _vm._s(_vm.$t(_vm.lblSetting.receptionCharacterProblem))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs10: "" } }, [
                _c("span", {
                  staticClass: "sub-title--text primary--text  ml-4",
                  domProps: { textContent: _vm._s(_vm.characterProblemName) }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "mb-3", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs3: "" } }, [
                _c("span", { staticClass: "primary--text" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.lblSetting.receptionComment)))
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs4: "" } },
                [
                  _c("v-textarea", {
                    attrs: {
                      name: "input-7-1",
                      readonly: "",
                      box: "",
                      rows: 2,
                      value: _vm.comment,
                      counter: _vm.textConfigs.textarea,
                      maxlength: _vm.textConfigs.textarea
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "mb-3", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs3: "" } }, [
                _c("span", { staticClass: "primary--text" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.lblSetting.receptionPhoto)))
                ])
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs4: "" } },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "" } },
                    _vm._l(_vm.item_medias, function(attachment, index) {
                      return attachment.media
                        ? _c(
                            "v-flex",
                            {
                              key: attachment.media.fk_media,
                              staticStyle: {
                                width: "100px",
                                height: "100px",
                                background: "#f8f8f8"
                              },
                              attrs: { xs4: "" }
                            },
                            [
                              _c("img", {
                                directives: [{ name: "img", rawName: "v-img" }],
                                staticClass: "message__image",
                                staticStyle: {
                                  width: "100%",
                                  height: "100%",
                                  "object-fit": "cover"
                                },
                                attrs: { src: attachment.media.link }
                              })
                            ]
                          )
                        : _vm._e()
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a40adec2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a40adec2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/mh-reception/components/mh-reception-section-detail/template.html
// module id = null
// module chunks = 